import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ProfileProps {
  className?: string;
  width?: number;
  height?: number;
}

const ProfileIcon = function ProfileIcon({
  className,
  width,
  height,
}: ProfileProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      {/* fill-[rgba(255, 255, 255, .1)] */}
      <circle className={twMerge('', className)} cx="12" cy="10" r="3" />
      <circle className={twMerge(className, 'fill-none')} cx="12" cy="12" r="9" strokeWidth="1.2" />
      <path className={twMerge('fill-transparent', className)} d="M17.8719 18.8083C17.9489 18.7468 17.9799 18.6436 17.9452 18.5513C17.5693 17.5518 16.8134 16.6706 15.7814 16.0332C14.6966 15.3632 13.3674 15 12 15C10.6326 15 9.30341 15.3632 8.21858 16.0332C7.18663 16.6706 6.43066 17.5518 6.05477 18.5513C6.02009 18.6436 6.05115 18.7468 6.12813 18.8083C9.56196 21.552 14.438 21.552 17.8719 18.8083Z" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};

ProfileIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default ProfileIcon;
